import {I18n} from '@aws-amplify/core';

import {
    Anchor,
    Box,
    Center,
    Group,
    Stack,
    Text,
} from '@mantine/core';

import {
    NextButton,
    PlatformFieldset
} from "@pac/platform-ui-components";

// Same choice and wording as legacy method selection, without its account-list route params.
export const MethodSelection = ({
                                    handleSSOButtonClick,
                                    handlePasswordClick,
                                }: {
    handleSSOButtonClick: () => void,
    handlePasswordClick?: () => void,
}) => {

    const text = [
        I18n.get(
            'You have enabled Sign-In using both password and Single Sign-On (SSO)'
        ),
        I18n.get('Please make a selection below or change Sign-in options'),
    ].join('. ');

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Sign In Method Selection'}>
                <Text>{I18n.get(text)}</Text>
                <Center>
                    <Group my={'xl'}>
                        <Box>
                            <NextButton onClick={handleSSOButtonClick}>
                                {I18n.get('Use SSO')}
                            </NextButton>
                        </Box>
                        {handlePasswordClick && (
                            <>
                                <Box>{I18n.get('or')}</Box>
                                <Box>
                                    <Anchor component="button" type="button" onClick={handlePasswordClick}>
                                        {I18n.get('Use username and password')}
                                    </Anchor>
                                </Box>
                            </>
                        )}
                    </Group>
                </Center>
            </PlatformFieldset>
        </Stack>
    );
};
